import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { FIRESTORE_TOKEN, FirestoreProvider } from '@core';
import { UnreadMessagesDTO } from '../dto';

export class UnreadMessagesService {
  private readonly firestoreProvider: FirestoreProvider = inject(FIRESTORE_TOKEN);

  unreadCount(userId: string): Observable<UnreadMessagesDTO[]> {
    return this.firestoreProvider.subcollectionSnapshot<UnreadMessagesDTO>(
      'chat-unread-messages',
      userId,
      'unread-channels'
    );
  }
}
